export const APP_ID = "application-1-vbmravu";